// packages
import PageLoader from '@/components/loaders/page-loader'
import React, { useState, createContext, useContext } from 'react'

// types
type LoadingContextProps = {
  isLoading: boolean
  setIsLoading(loading: boolean): void
}

// context
// @ts-expect-error
const LoadingContext = createContext<LoadingContextProps>()

const LoadingContextProvider = ({ children }: { children: Readonly<React.ReactNode> }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)

  return (
    <LoadingContext.Provider
      value={{
        isLoading,
        setIsLoading
      }}
    >
      {isLoading ? <PageLoader /> : children}
    </LoadingContext.Provider>
  )
}

const useLoader = () => {
  const context = useContext(LoadingContext)
  if (context === undefined) {
    throw new Error('useLoader must be used within a LoaderProvider')
  }
  return context
}
export { LoadingContext, LoadingContextProvider, useLoader }
